module.exports = __webpack_public_path__ + "static/media/maciek1.0e34a55b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maciek1.jpg
// module id = 31
// module chunks = 0